import { combineReducers, createSlice } from '@reduxjs/toolkit'
import snacksList from './components/AddSnackCoupon/reducer'

const yourOrderSlice = createSlice({
    name: 'yourOrder',
    initialState: {
        error: null,
        disable: false,
    },
    reducers: {
        setDisable(state, action) {
            const { payload } = action

            state.disable = payload
        },
        setError(state, action) {
            const { payload } = action

            if (!payload) {
                return { ...state, error: null }
            }

            return { ...state, error: payload }
        },
        changeTicketCategory() {},
    },
})

const { actions, reducer } = yourOrderSlice

export const { setDisable, setError, loadData, changeTicketCategory } = actions

//export default reducer

export default combineReducers({
    yourOrder: reducer,
    snacksList: snacksList,
})
